const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  salesItems: [],

};

const masterSlice = createSlice({
  name: "masterItems",
  initialState,
  reducers: {
    setSalesItem: (state, action) => {
      state.salesItems = action.payload;
    },

  },
});

export const { setSalesItem, setBatchNo } = masterSlice.actions;
export default masterSlice.reducer;
